import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@material-ui/core';
import LaunchIcon from '@material-ui/icons/Launch';
import { Link } from '@backstage/core-components';

export const LinksGroup = ({
  links,
}: {
  links?: { title?: string; url: string }[];
}) => {
  if (!links?.length) return null;

  return (
    <>
      {links.map((link, index) => (
        <ListItem key={index}>
          <ListItemIcon>
            <Tooltip title={link.title || link.url}>
              <LaunchIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText
            primary={
              <Link to={link.url} target="_blank" rel="noopener noreferrer">
                {link.title || link.url}
              </Link>
            }
          />
        </ListItem>
      ))}
    </>
  );
};
